/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './tx-auto-complete.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../app/shared/component/tx-auto-complete/tx-auto-complete.component';
import * as i4 from 'angular2-materialize/dist/materialize-directive';
const styles_TxAutoCompleteComponent:any[] = [i0.styles];
export const RenderType_TxAutoCompleteComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TxAutoCompleteComponent,data:{}});
function View_TxAutoCompleteComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'li',[['disabled',
      '']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(1,0,(null as any),(null as any),1,'a',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(2,
          (null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.emptyListText;
    _ck(_v,2,0,currVal_0);
  });
}
function View_TxAutoCompleteComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'li',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      1,'a',([] as any[]),(null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.selectItem(_v.context.$implicit)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(3,(null as any),['',''])),(_l()(),
      i1.ɵted(-1,(null as any),['\n  ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.getReadableValue(_v.context.$implicit);
    _ck(_v,3,0,currVal_0);
  });
}
function View_TxAutoCompleteComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'ul',[['class',
      'dropdown-content']],[[8,'id',0]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_TxAutoCompleteComponent_2)),
      i1.ɵdid(3,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TxAutoCompleteComponent_3)),
      i1.ɵdid(6,802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = ((_co.items.length === 0) || (_co.typedValue === ''));
    _ck(_v,3,0,currVal_1);
    const currVal_2:any = _co.items;
    _ck(_v,6,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.dropdownId;
    _ck(_v,0,0,currVal_0);
  });
}
function View_TxAutoCompleteComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'li',[['disabled',
      '']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(1,0,(null as any),(null as any),1,'a',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(2,
          (null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.emptyListText;
    _ck(_v,2,0,currVal_0);
  });
}
function View_TxAutoCompleteComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'li',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      1,'a',([] as any[]),(null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.selectItem(_v.context.$implicit)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(3,(null as any),['',''])),(_l()(),
      i1.ɵted(-1,(null as any),['\n  ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.getReadableValue(_v.context.$implicit);
    _ck(_v,3,0,currVal_0);
  });
}
function View_TxAutoCompleteComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'ul',[['class',
      'dropdown-content']],[[8,'id',0]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_TxAutoCompleteComponent_5)),
      i1.ɵdid(3,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TxAutoCompleteComponent_6)),
      i1.ɵdid(6,802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = ((_co.items.length === 0) || (_co.typedValue === ''));
    _ck(_v,3,0,currVal_1);
    const currVal_2:any = _co.filteredItems;
    _ck(_v,6,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.dropdownId;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_TxAutoCompleteComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),8,'div',[['class',
      'input-field']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,[['input',1]],
          (null as any),1,'input',[['class','autocomplete'],['data-beloworigin','true'],
              ['materialize','dropdown'],['type','text']],[[8,'disabled',0],[8,'value',
              0],[8,'id',0],[1,'data-activates',0]],[[(null as any),'input'],[(null as any),
              'focus'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.TxAutoCompleteComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>_co.inputObserver.next($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('focus' === en)) {
              const pd_1:any = ((<any>_co.inputOnFocus()) !== false);
              ad = (pd_1 && ad);
            }
            if (('blur' === en)) {
              const pd_2:any = ((<any>_co.inputOnBlur()) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(3,5128192,(null as any),0,i4.MaterializeDirective,
          [i1.ElementRef],{materialize:[0,'materialize']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵeld(5,0,(null as any),(null as any),
          2,'label',([] as any[]),[[8,'htmlFor',0]],(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(6,278528,(null as any),0,i2.NgClass,[i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),
      (_l()(),i1.ɵted(7,(null as any),['\n    ','\n  '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_TxAutoCompleteComponent_1)),
      i1.ɵdid(11,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TxAutoCompleteComponent_4)),
      i1.ɵdid(14,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:i3.TxAutoCompleteComponent = _v.component;
        const currVal_4:any = 'dropdown';
        _ck(_v,3,0,currVal_4);
        const currVal_6:any = i1.ɵinlineInterpolate(1,'',((_co.typedValue.length !== 0)? 'active': ''),
            '');
        _ck(_v,6,0,currVal_6);
        const currVal_8:boolean = !_co.performFilterInternally;
        _ck(_v,11,0,currVal_8);
        const currVal_9:any = _co.performFilterInternally;
        _ck(_v,14,0,currVal_9);
      },(_ck,_v) => {
        var _co:i3.TxAutoCompleteComponent = _v.component;
        const currVal_0:any = _co.disabled;
        const currVal_1:any = _co.typedValue;
        const currVal_2:any = (_co.id || _co.inputId);
        const currVal_3:any = _co.dropdownId;
        _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3);
        const currVal_5:any = (_co.id || _co.inputId);
        _ck(_v,5,0,currVal_5);
        const currVal_7:any = (((_co.items.length == 0) && _co.disabled)? _co.loadingLabel: _co.label);
        _ck(_v,7,0,currVal_7);
      });
}
export function View_TxAutoCompleteComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'tx-auto-complete',
      ([] as any[]),(null as any),(null as any),(null as any),View_TxAutoCompleteComponent_0,
      RenderType_TxAutoCompleteComponent)),i1.ɵdid(1,114688,(null as any),0,i3.TxAutoCompleteComponent,
      [i1.ChangeDetectorRef],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TxAutoCompleteComponentNgFactory:i1.ComponentFactory<i3.TxAutoCompleteComponent> = i1.ɵccf('tx-auto-complete',
    i3.TxAutoCompleteComponent,View_TxAutoCompleteComponent_Host_0,{items:'items',
        emptyListText:'emptyListText',label:'label',attributesTree:'attributesTree',
        performFilterInternally:'performFilterInternally',typedValue:'typedValue',
        disabled:'disabled',cleanFieldAfterSelect:'cleanFieldAfterSelect',id:'id',
        loadingLabel:'loadingLabel',dropdownId:'dropdownId'},{txOnItemSelect:'txOnItemSelect',
        txOnInput:'txOnInput'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/shared/component/tx-auto-complete/tx-auto-complete.component.ngfactory.ts